import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=3e856c54&scoped=true&"
import script from "./Door.vue?vue&type=script&lang=js&"
export * from "./Door.vue?vue&type=script&lang=js&"
import style0 from "./Door.vue?vue&type=style&index=0&id=3e856c54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e856c54",
  null
  
)

export default component.exports